var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"atom-vertical-line",style:(_vm.color ? { 'background-color': _vm.color } : {})})
}
var staticRenderFns = []

export { render, staticRenderFns }